import { useSyncExternalStore } from "react";

/** Тема класс-базовая (tailwind darkMode: "class"); подписка на смену класса `dark` у <html>.
 *  Нужна графикам recharts: цвета серий задаются строками, а не CSS-классами. */
export function useIsDark(): boolean {
  return useSyncExternalStore(
    (cb) => {
      const obs = new MutationObserver(cb);
      obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
      return () => obs.disconnect();
    },
    () => document.documentElement.classList.contains("dark"),
  );
}
